<div class="th-optional-container" 
[ngStyle]="{ 'margin-left': marginLeft, 'margin-right': marginRight }"
    >
    <p class="th-element">{{text}}</p>
</div>